module.exports = __webpack_public_path__ + "img/favicon-studio.60fa28f1.png";